import { AlertsInfo, AlertsState } from '../alerts';
import { ActionCallback, apiBase, AuthOut } from '../api';
import { DefaultSettings } from '../config/config';
import { LanguageType, PageOut } from '../config/misc';
import { SubscriptionsPaymentInvoice, SubscriptionsPaymentMethod, SubscriptionsPayment } from '../config/plans';
import { TickerInfo } from '../config/tickers';
import { BuiltAlertTicker, GetMyTickersOut, SearchTickersIn, TickersStat, UserSubInfo, UserTicker } from '../config/user';

export class userApi extends apiBase {
	public static errorHandler: ActionCallback<string>;

	public static post<TOut>(n: string, i: any = null) {
		return new Promise<TOut>((res, rej) => {
			apiBase.postData<TOut>('user/' + n, (r) => {
				if (r.error != null) {
					if (userApi.errorHandler)
						userApi.errorHandler(r.error);
					rej(r.error);
				} else {
					res(r.d);
				}
			}, i);
		});
	}
	public static applyPromo = (promo: string) =>
		userApi.post<number>("applyPromo", promo);

	public static agreeTermsOfService = () => userApi.post<AuthOut>("agreeTermsOfService");

	public static signOut = () => userApi.post<string>("signOut");

	public static setTickers = (input: UserTicker[]) => userApi.post<void>("setTickers", input);

	public static getTickers = (input: TickersStat) => userApi.post<GetMyTickersOut>("getTickers", input);

	public static getTickersInfo = (tids: string[]) => userApi.post<TickerInfo[]>("getTickersInfo", tids); 

	public static searchTickers = (input: SearchTickersIn) => userApi.post<PageOut<TickerInfo>>("searchTickers", input);

	public static getUserSubInfo = () => userApi.post<UserSubInfo>("getUserSubInfo");

	public static changePwd = (oldPwd: string, newPwd: string) => userApi.post<UserSubInfo>("changePwd", {
		new: newPwd,
		old: oldPwd
	});

	public static saveLayout = (name: string, content: any) => userApi.post<string>("saveLayout", {
		n: name,
		c: JSON.stringify(content),
		r: false,
	});

	public static saveLayoutSort(names: string[]) {
		return userApi.post<void>("saveLayoutSort", names);
	}
	public static removeLayout(name: string) {
		return userApi.post<string>("removeLayout", name);
	}
	public static renameLayout(oldname: string, newname: string) {
		return userApi.post<string>("saveLayout", {
			n: oldname,
			c: newname,
			r: true,
		});
	}
	public static removeTemplate(template: string) {
		return userApi.post<void>("removeTemplate", template);
	}
	public static getDefaultSettings(template: string, referrer: boolean) {
		return userApi.post<DefaultSettings>("getDefaultSettings", {
			template: template,
			referrer: referrer
		});
	}
	public static restoreSettings(config: DefaultSettings) {
		return userApi.post<DefaultSettings>("restoreSettings", config);
	}
	public static deleteAlerts(name: string) {
		return userApi.post<string>("deleteAlerts", name);
	}
	public static saveAlerts(alerts: AlertsState) {
		return userApi.post<string>("saveAlerts", alerts);
	}
	public static saveAlertsAs(alerts: AlertsState, name: string) {
		return userApi.post<string>("saveAlertsAs", {
			alerts: alerts,
			template: name
		});
	}
	public static deleteAlertMsg = (tid: string) => userApi.post<void>("deleteAlertMsg", tid);
	public static loadAlertMsgs = () => userApi.post<BuiltAlertTicker[]>("loadAlertMsgs");

	public static loadAlerts = () => userApi.post<AlertsInfo>("loadAlerts");

	public static loadTickersFilter = () => userApi.post<TickersStat>("loadTickersFilter");

	public static saveTickersFilter = (state: TickersStat) => userApi.post<void>("saveTickersFilter", state);

	public static loadAlertsAs = (isKey: boolean, name: string = null) => userApi.post<AlertsState>("loadAlertsAs", {
		isKey: isKey,
		name: name
	});

	public static createInvoice = (i: SubscriptionsPayment) => userApi.post<SubscriptionsPaymentInvoice>("createInvoice", i);

	public static getPaymentMethods = (i: SubscriptionsPayment) => userApi.post<SubscriptionsPaymentMethod[]>("getPaymentMethods", i);

	public static setLang = (i: LanguageType) => userApi.post<void>("setLang", i);

	public static saveDrawings = (tid: string, drawings: string) => userApi.post<void>("saveDrawings", { tid: tid, drawings: drawings });

	public static loadDrawings = (tid: string) => userApi.post<string>("loadDrawings", tid);
}
